// extracted by mini-css-extract-plugin
module.exports = {"banner":"locked-banner_banner___OAF9","width-wrapper":"locked-banner_width-wrapper__mOmR7","main-wrapper":"locked-banner_main-wrapper__dasTO"};